module.exports = __webpack_public_path__ + "static/media/helsinki-port.30b7addb.webp";